import React, { useRef } from "react";
import "./TokenInput.css";

const TokenInput = ({ token, setToken }) => {
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const inputValue = e.target.value.replace(/\D/g, "");
    if (!inputValue) return;

    const newToken = [...token];

    for (let i = 0; i < inputValue.length && index + i < token.length; i++) {
      newToken[index + i] = inputValue[i];
    }

    setToken(newToken);

    const nextIndex = index + inputValue.length;
    if (nextIndex < token.length) {
      inputsRef.current[nextIndex]?.focus();
    }

    e.target.value = inputValue[0];
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newToken = [...token];

      if (token[index]) {
        newToken[index] = "";
        setToken(newToken);
      } else if (index > 0) {
        inputsRef.current[index - 1]?.focus();
        newToken[index - 1] = "";
        setToken(newToken);
      }
    }
  };

  const handlePaste = (e, index) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "");
    const newToken = [...token];

    for (let i = 0; i < pasted.length && index + i < token.length; i++) {
      newToken[index + i] = pasted[i];
    }

    setToken(newToken);

    const next = index + pasted.length;
    if (next < token.length) {
      inputsRef.current[next]?.focus();
    }
  };

  return (
    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
      {token.map((value, index) => (
        <input
          key={index}
          id={`token-input-${index}`}
          ref={(el) => (inputsRef.current[index] = el)}
          type="tel"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="one-time-code"
          value={value}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={(e) => handlePaste(e, index)}
          className="inputToken"
        />
      ))}
    </div>
  );
};

export default TokenInput;
